import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { ChangeEvent } from "@saleor/hooks/useForm";
import useNotifier from "@saleor/hooks/useNotifier";
import { DialogProps } from "@saleor/types";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

const useStyles = makeStyles(
  {
    addTopMargin: {
      marginTop: "10px"
    }
  },
  {
    name: "CancelDialog"
  }
);
export interface OrderCancelDialogProps extends DialogProps {
  handleSubmit: any;
  onChange: (event: React.ChangeEvent<any>) => void;
  data: any;
  name: string;
  isOrderGrab?: boolean | null | undefined;
}

const OrderCancelDialog: React.FC<OrderCancelDialogProps> = props => {
  const {
    data,
    handleSubmit,
    name,
    onChange,
    onClose,
    open,
    isOrderGrab
  } = props;

  const classes = useStyles(props);

  const [enableText, setEnableText] = useState(true);
  const [inputVal, setInputVal] = useState();

  const notify = useNotifier();

  function handleChange(
    value: any,
    name: any,
    onChange: (event: ChangeEvent<any>) => void
  ) {
    if (value.target.value === "Others") {
      setEnableText(false);
    } else {
      setEnableText(true);
      setInputVal(null);
    }
    if (value) {
      onChange({
        target: {
          name,
          value: value.target.value
        }
      });
    }
  }

  const handleInput = (event: React.ChangeEvent<any>) => {
    setInputVal(event.target.value);
  };

  const handleConfirmSubmit = cancelReasonData => {
    if (cancelReasonData) {
      handleSubmit({
        cancelReason: cancelReasonData
      });
      onClose();
    } else {
      if (isOrderGrab) {
        setInputVal(data && data.cancelReason);
      } else {
        notify({
          status: "error",
          text: intl.formatMessage({
            defaultMessage:
              "Unable to cancel. Please provide the reason of cancellation."
          })
        });
      }
    }
  };

  const intl = useIntl();

  const cancelTypes = [
    { label: "Out of stock", value: "Out of stock" },
    { label: "Duplicate Order", value: "Duplicate Order" },
    { label: "Wrong Pin Location", value: "Wrong Pin Location" },
    { label: "Out of Service Area", value: "Out of Service Area" },
    { label: "To Apply Voucher", value: "To Apply Voucher" },
    { label: "Voucher Error", value: "Voucher Error" },
    { label: "Customer Declined", value: "Customer Declined" },
    { label: "Customer No Show", value: "Customer No Show" },
    { label: "Change of Mind", value: "Change of Mind" },
    { label: "Operations Issue", value: "Operations Issue" },
    { label: "Store Cannot Fulfill", value: "Store Cannot Fulfill" },
    { label: "Inclement Weather", value: "Inclement Weather" },
    { label: "Technical Issue", value: "Technical Issue" },
    {
      label: "Breach in Voucher Mechanics",
      value: "Breach in Voucher Mechanics"
    },
    { label: "QA - Test Order", value: "QA - Test Order" },
    {
      label: "Customer - Incorrect Delivery Type",
      value: "Customer - Incorrect Delivery Type"
    },
    { label: "Customer - Incorrect Mall", value: "Customer - Incorrect Mall" }
  ];

  return (
    <Dialog onClose={onClose} open={open} maxWidth="xs" fullWidth>
      <>
        <DialogTitle>Cancel Order</DialogTitle>
        <DialogContent>
          Are you sure you want to cancel this order?
          <br />
          Please select the reason of cancellation.
          <SingleSelectField
            className={classes.addTopMargin}
            label={intl.formatMessage({
              defaultMessage: "Reason of cancellation"
            })}
            disabled={false}
            value={data && data.cancelType}
            onChange={value => handleChange(value, name, onChange)}
            choices={cancelTypes}
            name="cancelType"
          />
          {enableText === false ? (
            <TextField
              id="cancelInputTxt"
              className={classes.addTopMargin}
              name="cancelInput"
              label="Specify other reason here"
              onChange={handleInput}
              fullWidth
              multiline
              rows={6}
              defaultValue={isOrderGrab ? inputVal : null}
            />
          ) : null}
        </DialogContent>
        <DialogActions>
          <div>
            <Button
              id="cancelDialogActionBtn"
              autoFocus
              onClick={onClose}
              color="secondary"
              style={{ marginRight: 10 }}
            >
              <FormattedMessage defaultMessage="Cancel" description="button" />
            </Button>
            {enableText ? (
              <Button
                id="confirmDialogActionBtn"
                autoFocus
                onClick={() => handleConfirmSubmit(data && data.cancelType)}
                color="primary"
                variant="contained"
              >
                <FormattedMessage
                  defaultMessage="Confirm"
                  description="button"
                />
              </Button>
            ) : (
              <Button
                id="confirm2DialogActionBtn"
                autoFocus
                onClick={() => handleConfirmSubmit(inputVal)}
                color="primary"
                variant="contained"
              >
                <FormattedMessage
                  defaultMessage="Confirm"
                  description="button"
                />
              </Button>
            )}
          </div>
        </DialogActions>
      </>
    </Dialog>
  );
};
OrderCancelDialog.displayName = "OrderCancelDialog";
export default OrderCancelDialog;
